import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { ServiceService } from '../../api';
import { AuftragDefaultServiceModel } from '../../models/AuftragDefaultServiceModel';
import { ServiceModel } from '../../models/ServiceModel';
//#84367

export const getDynamicAuftragServices =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new ServiceService().getDefaultAuftragServices().then(response => {
      dispatch({
        type: ActionTypes.GET_DYNAMIC_AUFTRAG_SERVICES,
        payload: response.data,
      });
    });
  };

const startIndex = 5; //4 Mögliche Services sind Hartcodiert in 'DefaultServices.ts'.

export const convertDynamicToServiceModel = (
  listToConvert: AuftragDefaultServiceModel[]
): ServiceModel[] => {
  const serviceModels = listToConvert.map((item, index) => {
    return {
      id: index + startIndex,
      elementId: index + startIndex,
      bezeichnung: item.bezkurz ?? '',
      wert: '',
      hinweis: false,
      active: false,
      editable: item.typ != 'Logisch',
      defaultService: true,
      attributName: item.bezkurz ?? '',
      //isKostenpfl: true,
      isKostenpfl: true,
      spez_num: item.spezNum ?? '',
      typ: item.typ ?? undefined,
      backgroundColor: 'bg-orange400',
      isAWSperre: item.awSperre,
    } as ServiceModel;
  });

  return serviceModels;
};

export const convertDynamicToServiceModelBEXITY = (
  listToConvert: AuftragDefaultServiceModel[]
): ServiceModel[] => {
  let serviceModels = convertDynamicToServiceModel(listToConvert);
  //BEXity Services richtig setzten
  serviceModels = ReplaceServiceModelBEXITY(serviceModels);

  return serviceModels;
};

export const ReplaceServiceModelBEXITY = (
  listToConvert: ServiceModel[]
): ServiceModel[] => {
  listToConvert.forEach(item => {
    switch (item.spez_num) {
      case 48:
        if (item.bezeichnung === 'Abtragen') {
          item.backgroundColor = 'bg-green900';
          item.isKostenpfl = true;
          item.isAWSperre = false;
        }
        break;
      case 49:
        if (item.bezeichnung === 'Lenkeravis') {
          item.backgroundColor = 'bg-lightBlueA200';
          item.isKostenpfl = true;
          item.isAWSperre = false;
        }
        break;
      case 151:
        item.backgroundColor = 'bg-lime600';
        item.isKostenpfl = false;
        item.isAWSperre = false;
        item.attributName = 'myDelivery';
        break;
      case 152:
        item.backgroundColor = 'bg-amber700';
        item.isKostenpfl = false;
        item.isAWSperre = false;
        item.attributName = 'adv3';
        break;
    }
  });
  return listToConvert;
};
